import { render, staticRenderFns } from "./DeleteCompetition.vue?vue&type=template&id=30c2cf6c&scoped=true"
import script from "./DeleteCompetition.vue?vue&type=script&lang=js"
export * from "./DeleteCompetition.vue?vue&type=script&lang=js"
import style0 from "./DeleteCompetition.vue?vue&type=style&index=0&id=30c2cf6c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30c2cf6c",
  null
  
)

export default component.exports